import classNames from "classnames";

import Checkbox from "features/components/Checkbox";
import { Option, SelectOption } from "features/ui/Select";

interface CustomOptionProps {
  option: SelectOption<Option>;
  tempSelected: SelectOption<Option>[];
  setTempSelected: (option: SelectOption<Option>[]) => void;
  isMaxValueLimitReached?: boolean;
}

export const CustomOption = ({
  option,
  tempSelected,
  setTempSelected,
  isMaxValueLimitReached = false,
  ...props
}: CustomOptionProps) => {
  const isChecked = tempSelected.some(({ id }) => id === option.id);

  const handleClick = (e: React.MouseEvent<HTMLLIElement>) => {
    e.preventDefault(); // prevent Autocomplete default selection
    const exists = tempSelected.find(({ id }) => id === option.id);
    if (exists) {
      setTempSelected(tempSelected.filter(({ id }) => id !== option.id));
    } else {
      setTempSelected([...tempSelected, option]);
    }

    e.stopPropagation();
  };

  return (
    <li
      {...props}
      className={classNames("flex items-center pl-1", {
        "bg-slate-200 cursor-pointer": isChecked,
        "hover:bg-slate-100 cursor-pointer":
          !isMaxValueLimitReached || isChecked,
        "cursor-not-allowed": isMaxValueLimitReached && !isChecked,
      })}
      title={option.value.toString()}
      aria-disabled={isMaxValueLimitReached}
      onClick={handleClick}
    >
      <Checkbox
        checked={isChecked}
        label={(option.label || option.value).toString()} // label
        onChange={() => {}} // required prop, but onChange is handled by Autocomplete
        disabled={!isChecked && isMaxValueLimitReached}
      />
    </li>
  );
};
